<template>
  <div>
    <a-modal
      width="1200px"
      v-model="isShow"
      centered
      :mask-closable="false"
      title="预制项目详情"
    >
      <template slot="footer">
        <a-spin :spinning="loading">
          <div>
            <a-space>
              <div>
                <a-button
                  @click="closeModal"
                >
                  关闭
                </a-button>
              </div>
              <div v-if="hasOperatePermission">
                <div
                  v-if="data.status_slug === 'check_store' || data.status_slug === 'check_resource_all'
                    || data.status_slug === 'check_resource_party_of' || data.status_slug === 'pending_purchase'"
                >
                  <a-button
                    type="primary"
                    @click="showModal('cancel')"
                    v-if="isShowMenu('agent_pre_order_items/cancel')"
                  >
                    取消
                  </a-button>

                  <a-button
                    type="primary"
                    @click="showModal('check_store')"
                    v-if="['check_store'].includes(data.status_slug) && isShowMenu('agent_pre_order_items/check_store')"
                  >
                    核库
                  </a-button>

                  <a-button
                    type="primary"
                    @click="showModal('check_resource')"
                    v-if="['check_resource_all', 'check_resource_party_of'].includes(data.status_slug) && isShowMenu('agent_pre_order_items/check_resource')"
                  >
                    核资
                  </a-button>

                  <a-button
                    type="primary"
                    @click="checkPurchase()"
                    v-if="['check_resource_party_of', 'pending_purchase'].includes(data.status_slug) && isShowMenu('agent_pre_order_items/pending_purchase')"
                  >
                    订购
                  </a-button>
                </div>
              </div>
            </a-space>
          </div>
        </a-spin>
      </template>
      <a-spin :spinning="loading">
        <agent-pre-order-item-basic-info :data="data" />

        <a-descriptions title="项目操作历史" :column="1" />
        <agent-pre-order-item-event-list :item-id="id" />
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { findAgentPreOrderItem, putAgentPreOrderItemToCart } from '@/api/agent_pre_order_item'
import AgentPreOrderItemBasicInfo from '@/views/agent_pre_order_items/show/BasicInfo'
import AgentPreOrderItemEventList from '@/views/agent_pre_order_item_events/index'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'ShowAgentPreOrderItem',
  components: {
    AgentPreOrderItemBasicInfo,
    AgentPreOrderItemEventList
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    hasOperatePermission() {
      return this.isShowMenu('agent_pre_order_items/operate')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    checkPurchase() {
      if (this.data.product_type_slug === 'sim_card') {
        var id = this.id
        this.$confirm({
          title: '复制预制项目直接订购?',
          content: '',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            putAgentPreOrderItemToCart(id).then(res => {
            //   if (res.code === 0) {

            //   }
            })
          }
        })
      } else {
        this.showModal('pending_purchase')
      }
    },

    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showModal(operateType) {
      this.isShow = false
      this.$emit('showModal', operateType)
    },

    fetchData() {
      this.loading = true
      findAgentPreOrderItem(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
        this.loading = false
      })
    },

    closeModal() {
      this.isShow = false
    }
  }
}
</script>
